import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { setAppError } from "../../actions/App/dispatchers";
import { HTTP_UNPROCESSABLE_ENTITY } from "../../constants/http";

/**
 * @param name String - name of the url parameter.
 * @param validator Function - a function to validate the url parameter.
 * return the parameter value, or null if not defined.
 */

export default function useParam(name, validator) {
    const dispatch = useDispatch();
    const location = useLocation();
    const params = new URLSearchParams(location?.search);
    if (params.has(name)) {
        const param = params.get(name);
        if (validator(param)) {
            return param;
        } else {
            dispatch(setAppError(params.toString(), HTTP_UNPROCESSABLE_ENTITY));
        }
    }
    return null;
}
